<template>
  <div class="header">
    <div class="header-activity">
      <div class="header-activity-wrap">
        <el-tooltip
          effect="light"
          popper-class="tool-tooltip"
          content="返回"
          placement="bottom"
        >
          <img
            @click="iconHome"
            class="header-activity-wrap__home"
            :src="imageCdn + '/home.svg'"
            alt=""
          />
        </el-tooltip>
        <el-dropdown
          size="medium"
          placement="top-start"
          trigger="click"
          @command="activityCommand"
        >
          <i class="el-icon-arrow-down"></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="item in activityData"
              :key="item.value"
              :command="item"
              ><span class="activity-title">
                {{ item.activityName }}</span
              ></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="header-activity__name">
        <slot name="activityName"></slot>
      </div>
    </div>
    <div class="header-activity-design">
      <img
        v-if="getStatusClass"
        class="header-activity-design__icon"
        :src="imageCdn + '/design.svg'"
      />
      <i
        v-else
        class="header-activity-design-success iconfont icontijiaochenggong"
      ></i>
      <div
        :class="[
          'header-activity-design__green',
          { 'header-activity-design__active': getStatusClass },
        ]"
      >
        {{ getStatusText }}
      </div>
    </div>
    <el-tooltip
      effect="light"
      popper-class="tool-tooltip"
      content="引用"
      placement="bottom"
    >
      <div
        :class="['header-activity-item', { disabled: getDiabled }]"
        @click="dialogVisiTemp"
      >
        <img
          class="header-activity-item__icon"
          :src="imageCdn + '/template.svg'"
        />
        <div class="header-activity-item__title">引用</div>
      </div>
    </el-tooltip>
    <el-tooltip
      effect="light"
      popper-class="tool-tooltip"
      content="另存为"
      placement="bottom"
    >
      <div class="header-activity-item" @click="saveAstemplateClick">
        <img class="header-activity-item__icon" :src="imageCdn + '/save.svg'" />
        <div class="header-activity-item__title">另存为</div>
      </div>
    </el-tooltip>
    <el-tooltip
      v-if="isReplaceOne"
      effect="light"
      popper-class="tool-tooltip"
      :content="isCanImportCanvas ? '导入画布' : '使用该功能需开通云舟专业版/数智版，请联系您的专属客服处理哦~'"
      placement="bottom"
    >
      <div
        :class="['header-activity-item', { disabled: !isCanImportCanvas }]"
        @click="importCanvas"
      >
        <img
          class="header-activity-item__icon"
          :src="imageCdn + '/import.svg'"
        />
        <div class="header-activity-item__title">导入画布</div>
      </div>
    </el-tooltip>
    <div class="header-activity-item" v-if="hasExport">
      <el-tooltip
        effect="light"
        popper-class="tool-tooltip"
        content="导出短信营销效果报表"
        placement="top"
      >
        <el-dropdown size="medium" placement="top" @command="exportCommand">
          <div class="header-activity-wrap">
            <img
              class="header-activity-item__icon"
              :src="imageCdn + '/export.svg'"
            />
            <div class="header-activity-item__title">导出</div>
            <img
              class="header-activity-item__down"
              :src="imageCdn + '/down.svg'"
            />
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="item in exportOptions"
              :key="item.value"
              :command="item.value"
              :disabled="getExportDisabled(item.value)"
              ><span :class="getExportDisabled(item.value) ? 'disabled-title' : 'export-title'">
                {{ item.label }}</span
              ></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </el-tooltip>
    </div>
    <el-tooltip
      effect="light"
      popper-class="tool-tooltip"
      content="使用教程"
      placement="bottom"
    >
      <div class="header-activity-item" @click="usingTutorials">
        <img
          class="header-activity-item__icon"
          :src="imageCdn + '/usingTutorials.svg'"
        />
        <div class="header-activity-item__title">使用教程</div>
      </div>
    </el-tooltip>
    <div>
      <el-popover placement="right" width="500" trigger="hover">
        <div class="header-activity-tip">
          <div>
            1.发送时间范围（普通短信和图文短信）：早9:00-晚20:00（日常）
          </div>
          <div>
            2.日常频控规则：同一店铺
            1天内给同一手机号发送商家营销短信的条数不超过 2条；每个手机号每
            1天只能收到 6条商家营销短信。
          </div>
        </div>
        <div class="header-activity-rule" slot="reference">
          <div class="header-activity-rule__active">发送规则</div>
          <img
            class="header-activity-rule__icon"
            :src="imageCdn + '/question_active.svg'"
          />
        </div>
      </el-popover>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    statusNum: {
      type: [String, Number],
      default: "",
    },
    activityData: {
      type: Array,
      default: () => {},
    },
    isReplaceOne: {
      type: Boolean,
      default: false,
    },
    hasExport: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      exportOptions: [
        {
          label: "营销效果导出",
          value: 1,
        },
        {
          label: "咚咚效果导出",
          value: 4,
        },
        {
          label: "人群分析导出",
          value: 2,
        },
        {
          label: "画布导出（仅排重）",
          value: 3,
        },
      ],
      imageCdn:
        "https://cdn-image.yucrm.cn/images/yuqiyunzhou/intelligent/tools",
    };
  },
  computed: {
    getStatusText() {
      let str = "正式执行中";
      const status = Number(this.statusNum);
      switch (status) {
        case 0:
          str = "设计中";
          break;
        case 2:
          str = "已结束";
          break;
        case 3:
          str = "测试执行中";
          break;
        case 4:
          str = "测试执行完成";
          break;
        case 5:
          str = "等待执行";
          break;
        case 6:
          str = "等待下次执行";
          break;
        case 7:
          str = "已停止";
          break;
        case 8:
          str = "执行异常";
          break;
      }
      return str;
    },
    getStatusClass() {
      return this.statusNum == 0 || this.statusNum == 1 || this.statusNum == 3;
    },
    getDiabled() {
      return (
        this.statusNum == 1 ||
        this.statusNum == 5 ||
        this.statusNum == 3 ||
        this.statusNum == 4 ||
        this.statusNum == 2 ||
        this.statusNum == 8 ||
        this.statusNum == 7
      );
    },
    getExportDisabled() {
      // 2已结束 6等待下次执行
      return (val) => {
        // 画布导出（仅排重）
        if (val == 3) {
          return (
            (this.statusNum != 2 && this.statusNum != 6) || this.statusNum == 4
          );
        } else {
          return this.statusNum != 2 && this.statusNum != 6;
        }
      };
    },
    // 导入画布权限
    isCanImportCanvas() {
      const permissions = this.$store.getters.loginUserInfo.permissions;
      let isCan = permissions.includes("intelligent_marketing:canvas:import");
      return isCan;
    },
  },
  methods: {
    activityCommand(val) {
      this.$emit("activityCommand", val);
    },
    // 返回列表
    iconHome() {
      this.$emit("iconHome");
    },
    // 引用模板
    dialogVisiTemp() {
      if (this.getDiabled) return;
      this.$emit("dialogVisiTemp");
    },
    // 另存为
    saveAstemplateClick() {
      this.$emit("saveAstemplateClick");
    },
    // 导入画布
    importCanvas() {
      if(!this.isCanImportCanvas) return;
      this.$emit("importCanvas");
    },
    // 导出画布
    exportCommand(val) {
      this.$emit("effectReport", val);
    },
    // 使用教程
    usingTutorials() {
      this.$emit("usingTutorials");
    },
  },
};
</script>

<style tool-tooltip>
.tool-tooltip {
  color: #4f4f4f;
}
</style>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  padding: 10px 0px;
  &-activity {
    display: flex;
    align-items: center;
    &-tip {
      color: #4f4f4f;
      font-size: 12px;
    }
    &__name {
      margin-left: 11px;
      width: 141px;
    }
    &-design {
      margin: 0px 20px;
      display: flex;
      align-items: center;
      font-size: 12px;
      &__icon {
        width: 14px;
        height: 14px;
      }
      &-success {
        color: #11b949;
        margin-right: 5px;
        font-size: 14px;
      }
      &__green {
        color: #11b949;
      }
      &__active {
        color: #3159ff;
        margin-left: 5px;
      }
    }
    &-rule {
      display: flex;
      align-items: center;
      cursor: default;
      font-size: 12px;
      &__icon {
        width: 14px;
        height: 14px;
      }
      &__active {
        color: #3159ff;
        margin-right: 5px;
      }
    }
    &-wrap {
      display: flex;
      align-items: center;
      &__home {
        width: 16px !important;
        height: 16px !important;
        cursor: pointer;
        padding: 2px;
        box-sizing: content-box;
        border-radius: 2px;
        &:hover {
          background-color: #f2f4f9;
        }
      }
      .el-icon-arrow-down {
        margin-left: 4px;
      }
    }
    &-item {
      display: flex;
      align-items: center;
      margin-right: 12px;
      padding-right: 4px;
      cursor: pointer;
      &:hover {
        background-color: #f2f4f9;
        border-radius: 2px;
      }
      &__title {
        color: #4f4f4f;
        font-size: 12px;
      }
      &__icon {
        width: 20px;
        height: 20px;
      }
      &__down {
        width: 12px;
        height: 12px;
      }
      &__active {
        color: #3159ff;
        margin-right: 5px;
      }
    }
  }
}
.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  user-select: none;
  &:hover {
    background-color: transparent;
  }
}

.export-title {
  font-size: 12px;
  color: #333333;
}

.activity-title {
  color: #4f4f4f;
}
.disabled-title{
  font-size: 12px;
  color: #bbb;
  :hover{
    cursor: not-allowed;
  }
}
</style>
